<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>ACKNOWLEDGEMENTS</b></p>
<p class="noindent">Special thanks to the following for their priceless contributions and assistance: Jack Nickels, the Rocky River Historical Society; Louise Varisco, the Strongsville Historical Village; George and Mary Krejci, Chad Thomas, John Nanovsky, Matthew Rump, Ryan McCarbery, Patricia Mahon, Rebecca E. Haaga, Amanda Francazio and Greg Palumbo, the Lakewood Historical Society; Paul Nelson, the Western Reserve Fire Museum and Education Center; Gayle Hill and Charles Cassady Jr., the Western Reserve Historical Society; Ware Petznick, the Shaker Historical Society; Marcia Anselmo, the Gates Mills Historical Society; Roy Larick and Dave Lawrence, the Euclid Historical Museum; the Cleveland Public Library; Cleveland State University; Janet Wood; Lucy Fiore; and Laura Hine.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?125e7714